<template>
  <modal wrapperClasses="passcode">
    <div slot="body" class="modal-content">
      <div class="content">create a 4-digit PIN for secure access to our offers and content</div>
      <passcode-input
        label="PIN"
        :passcode.sync="passcode" />
      <passcode-input
        label="confirm PIN"
        :passcode.sync="confirmPasscode"
        :autoFocus="false" />
      <div v-if="error" class="error">{{ error }}</div>
      <div class="remember_me align-left">
        <sb-checkbox :checked.sync="rememberMe" />
        <label for="remember">remember me</label>
      </div>
    </div>
    <div slot="action" class="modal-click-action">
      <button @click="clickedEnter()" class="button submit">enter</button>
    </div>
  </modal>
</template>

<script>
  import Modal from '../../components/shared/Modal'
  import { passcodeAPI } from "../../services/api/passcode"
  import PasscodeInput from '../../components/shared/PasscodeInput'

  export default {
    name: 'CreatePasscodeModal',

    data(){
      return {
        confirmPasscode: '',
        error: '',
        passcode: '',
        rememberMe: true
      }
    },

    props:{
      memberAccessCode: Number
    },

    components: {
      Modal,
      PasscodeInput
    },

    computed: {
      encodedSecureLinkId(){
        return this.$route.params.id
      }
    },

    methods: {
      clearError(){
        return this.error = ''
      },

      clickedEnter(){
        if(!this.passcode || !this.confirmPasscode) return this.error = 'must enter PIN'
        if((this.passcode && this.confirmPasscode) && (this.passcode !== this.confirmPasscode)) return this.error = 'PIN codes do not match'
        return  passcodeAPI.postSetMemberPassword(
                  this.encodedSecureLinkId,
                  this.memberAccessCode,
                  this.passcode,
                  this.rememberMe
                )
                .then(data =>
                  this.$router.push({
                    name: 'Stashboard',
                    params: {
                      id: this.encodedSecureLinkId,
                      content: data.sms_content,
                      extensionType: data.type,
                      merchantName: data.merchant_name,
                      merchantWebsiteUrl: data.website,
                      urlButton: data.url,
                      urlImage: data.mms_cdn_link,
                      urlLogo: data.merchant_logo?.url
                    }
                  })
                )
                .catch(error =>  this.error = 'an error has occured, please try again')
      }
    },

    watch: {
      confirmPasscode(){
        this.clearError()
      },

      passcode(){
        this.clearError()
      }
    }
  }
</script>
